import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSortArrowUpDown: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="sort-arrow-up-down"><rect x="3.75" y="3.75" width="6.5" height="6.5" stroke="currentColor" strokeWidth="1.5"/><rect x="3.75" y="13.75" width="6.5" height="6.5" stroke="currentColor" strokeWidth="1.5"/><path d="M14.75 7.5L18 4L21.25 7.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M21.25 16.5L18 20L14.75 16.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M18 4.5V19.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSortArrowUpDown;
